// extracted by mini-css-extract-plugin
module.exports = {"ant-modal-body":"Generic_ant-modal-body__XOsXM"};